import React from 'react';
import FooterPartnersMain from "./FooterPartnersMain";
import FooterPartnersSub from "./FooterPartnersSub";
var FooterPartners = function (_a) {
    var children = _a.children;
    var footerPartnersMain = null;
    var footerParnersSub = null;
    var recupererElement = function (child) {
        switch (child.type) {
            case FooterPartnersMain:
                footerPartnersMain = child;
                break;
            case FooterPartnersSub:
                footerParnersSub = child;
                break;
        }
    };
    if (Array.isArray(children)) {
        children.forEach(function (child) {
            recupererElement(child);
        });
    }
    else {
        recupererElement(children);
    }
    return (React.createElement("div", { className: "fr-footer__partners" },
        React.createElement("h2", { className: "fr-footer__partners-title" }, "Nos partenaires"),
        React.createElement("div", { className: "fr-footer__partners-logos" },
            footerPartnersMain,
            footerParnersSub)));
};
export default FooterPartners;
